module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/babel-runtime/core-js/object/set-prototype-of.js
// module id = 3591
// module chunks = 0